import { Injectable } from '@angular/core';
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {BehaviorSubject, combineLatest, Subject, timer} from 'rxjs';
import {NearmapService} from '@src/app/services/nearmap/nearmap.service';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImageryProviderService {

  public bwToggle:any;
  public imageryLoaded: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private _selectedModeChanged: Subject<{name, mode}> = new Subject<any>();

  public nearmapConfig:any = false;

  get selectedModeChanged(){
    return this._selectedModeChanged.asObservable().pipe(filter(({name, mode})=> name && mode));
  }

  getSelectedMode(){
    return {name: this.selectedModeName, mode: this.selectedMode, nearmap: this.nearmapConfig};
  }

  public selectedModeName = null;
  public selectedMode = null;
  public prevSelectedMode = {name: null, val: null};
  private imageryList = null;

  constructor(public adapter: CesiumAdapterService, private nearMap: NearmapService) {
    this.adapter.currentImageryProvider.subscribe((providerID)=>{
      if (this.selectedMode) {
        return this.selectViewModeById(providerID);
      }
      this.setCurrentProvider(providerID);
    });

    this.adapter.updateBWStatus$.subscribe((status:boolean)=>{
      status ? this.enableBWMode() : this.disableBWMode();
    })

    this.adapter.imageryProvidersProvider.subscribe((providers) => {
      this.imageryList = providers;
      this.imageryLoaded.next(providers);
    });

    combineLatest(this.adapter.currentImageryProvider, this.adapter.imageryProvidersProvider).subscribe(([currentProviderId, imageryList])=>{
      if (imageryList){
        this.setCurrentProvider(currentProviderId);
      }
    })
  }

  private setCurrentProvider(providerID){
    for(let imageryName in this.imageryList){
      if (this.imageryList[imageryName].id == providerID){
        this.selectedMode = this.imageryList[imageryName].id;
        this.selectedModeName = imageryName;
        this._selectedModeChanged.next({name: imageryName, mode: this.imageryList[imageryName]});
        return;
      }
    }
  }

  setCurrentViewModeGrayScale(value){
    this.adapter.setCurrentViewModeGrayScale(value);
  }

  private enableBWMode(isUpdateMap?){
    // if (this.imageryList[this.selectedModeName].id != this.adapter.DEFAULT_BW_PROVIDER_ID && this.selectedModeName.toString().toLowerCase() !='black and white'){
    //   this.adapter.selectViewMode(this.adapter.DEFAULT_BW_PROVIDER_ID);
    // }

    if (this.selectedMode && this.selectedModeName){
      this.prevSelectedMode = {name: this.selectedModeName, val:this.selectedMode};
      //console.warn('enableBWMode__PROVIDER__Prev', this.prevSelectedMode);
    }

    this.selectedMode = this.imageryList['Black & White'].id;
    this.selectedModeName = 'Black & White';

    this._selectedModeChanged.next({name: this.selectedModeName, mode: this.imageryList['Black & White']});
    if (isUpdateMap){
      this.setCurrentViewModeGrayScale(0);
    }

  }

  disableBWMode(isUpdateMap?){

    if (!this.prevSelectedMode.val || !this.prevSelectedMode.name){
      return this.setCurrentProvider(this.adapter.getDefaultImageryProviderId());
    }

    if (this.prevSelectedMode.val && this.prevSelectedMode.name){
      this.selectedMode = this.prevSelectedMode.val;
      this.selectedModeName = this.prevSelectedMode.name;
    }

    this.prevSelectedMode.val = ('-1');
    this.prevSelectedMode.name = ('Black & White');


    this._selectedModeChanged.next({name: this.selectedModeName, mode: this.imageryList[this.selectedModeName]});
    if (isUpdateMap){
      this.setCurrentViewModeGrayScale(1);
    }
  }

  selectViewMode(modeName, modeVal){

    this.disableBWMode(true);

    /*if (this.selectedMode === modeVal['id']) {
      return;
    }*/

    this.prevSelectedMode = {name: this.selectedModeName, val:this.selectedMode};

    this.selectedMode = modeVal['id'];
    this.selectedModeName = modeName;
    this.setCurrentViewModeGrayScale(1);

    if (this.adapter.selectedImageryProvider !== modeVal['id']) {
      this.adapter.selectViewMode(modeVal['id']);
    }

    this._selectedModeChanged.next({name: modeName, mode: modeVal});

  }

  selectViewModeByName(name){
    if (!name && this.prevSelectedMode.name && this.prevSelectedMode.val){
      this.selectViewMode(this.prevSelectedMode.name, {id: this.prevSelectedMode.val});
      return;
    }
    else{
      let modeVal = this.imageryList[name];
      if (modeVal){
        this.selectViewMode(name, modeVal)
      }
    }
  }

  selectViewModeById(id) {
    for (let i in this.imageryList) {
      if (!this.imageryList.hasOwnProperty(i)) { continue; }
      if (this.imageryList[i].id == id) {
        return this.selectViewMode(i, this.imageryList[i]);
      }
    }
  }

  getEnvironmentConfig() {
    let additionalConfig = null;
    let resultObject = { id: this.selectedMode };
    if (this.selectedMode == 8){
      additionalConfig =  {availableDates: this.nearMap.availableDatesValue(), selectedDate: this.nearMap.getSelectedDateValue()};
      resultObject = Object.assign(resultObject, additionalConfig);
    }
    return resultObject;
  }

  setEnvironmentConfig(config, active = true) {
    if (config.hasOwnProperty('id')) {
      this.selectViewModeById(config.id);
      if (config.id == 8){
          let selectedDate = config.selectedDate;
          timer(1000).subscribe(()=>{
            console.log('setloaddate', selectedDate);
            this.nearMap.setLoadDate(selectedDate);
          })
      }
    }
  }
}

